export enum DashboardTranslateKeys {
  WELCOME = 'dashboard.welcome',
  BANNER_DESC = 'dashboard.bannerDescription',
  SEARCH_PLACEHOLDER = 'dashboard.searchHere',
  ALL = 'dashboard.all',
  RECRUITER = 'dashboard.recruiter',
  RECRUITMENT_PERF = 'dashboard.recruitmentPerf',
  JOB_OFFER_TRACK = 'dashboard.jobOfferTracking',
  PROCESS_EFFICIENCY = 'dashboard.processEfficiency',
  TOTAL_APPLICANTS_RECEIVED = 'dashboard.totalNumberApplicantsRec',
  TOTAL_APPLICANTS_RECRUITED = 'dashboard.totalNumberApplicantsRecruted',
  INFLUX_TALENT = 'dashboard.influxTalent',
  TALENTS_INTEGRATED = 'dashboard.talentsIntegrated',
  POSITIONS_TO_BE_FILLED = 'dashboard.positionsToBeFilled',
  STILL_OPPORTUNITIES = 'dashboard.stillOpportunities',
  NUMBER_RECRUITMENTS_CARRIED_OUT = 'dashboard.numberRecruitmentsCarriedOut',
  BY_DEFINITVE_OBJECTIVE = 'dashboard.byDefinedObjective',
  NUMBER_CARRIED_OUT = 'dashboard.numberCarriedOut',
  NUMBER_TARGETED = 'dashboard.numberTargeted',
  OFFERS = 'dashboard.offers',
  NUMBER = 'dashboard.number',
  CLOSED = 'menuLabel.jobs.closed',
  OVERALL_STATUS_OFFERS = 'dashboard.overallStatusOffers',
  WHERE_RECRUITMENTS = 'dashboard.whereRecruitments',
  WHERE_RECRUITMENTS_PER_STRUCTURE = 'dashboard.whereRecruitmentsPerStructure',
  OFFER_ACCEPTANCE_RATE = 'dashboard.offerAccepanceRate',
  OFFER_ACCEPTANCE_RATE_PER_STRUCTURE = 'dashboard.offerAccepanceRatePerStructure',
  ACCEPTED_PROPOSED = 'dashboard.acceptedProposed',
  ACCEPTED_PROPOSED_STRUCTURE = 'dashboard.acceptedProposedPerStructure',
  OFFER_PER_STRUCTURE = 'dashboard.offersPerStructure',
  OFFERS_ACCEPTED = 'dashboard.offersAccepted',
  OFFERS_PROPOSED = 'dashboard.offersProposed',
  IN_PROGRESS = 'dashboard.inProgress',
  FINISHED = 'dashboard.finished',
  NOT_PUBLISHED = 'dashboard.notPublished',
  NOT_PLANNED = 'dashboard.notPlanned',
  PERCENTAGE = 'dashboard.percentage',
  SUBSIDIARY = 'dashboard.subsidiary',
  AVERAGE_TIME_BETWEEN_APP_HIR = 'dashboard.averageTimeBetweenApplicationHiring',
  AVERAGE_DAYS_RECRUIT = 'dashboard.averageDaysRecruit',
  AVERAGE_TIME_BETWEEN_PUB_CLOS_RECR = 'dashboard.averageTimeBetweenPubClosRecr',
  FROM_OFFER_TO_HIR = 'dashboard.fromOfferToHir',
  CANDIDATE_PROFILE = 'dashboard.candidateProfile',
  DISTRIBUTION_BY_AGE = 'dashboard.distributionByAge',
  WHICH_GENERATION_JOINING = 'dashboard.whichGenerationJoining',
  DISTRIBUTION_BY_GENDER = 'dashboard.distributionByGender',
  DIVERSITY_BALANCE = 'dashboard.diversityBalance',
  GEOGRAPHIC_DISTRIBUTION = 'dashboard.geographicDistribution',
  EMPLOYEES = 'topbar.link.employees',
  MEN = 'dashboard.men',
  WOMEN = 'dashboard.women',
  YEAR = 'dashboard.year',
  M_YEAR = 'dashboard.mYear',
  CONTRACT = 'dashboard.contract',
  STRUCTURES = 'dashboard.structures',
  STRUCTURE = 'dashboard.structure',
  OFFER_STATUS = 'dashboard.offerStatus',
  ERROR = 'dashboard.error',
  ERROR_TRY_AGAIN = 'dashboard.errorTryAgain',
  NOT_SPECIFIED = 'utils.remoteWorkTypes.notSpecified',
  AGE_UNSPECIFIED = 'dashboard.unspecified',
  MONTH = 'dashboard.months',
  REALIZED = 'dashboard.realized',
  GOAL = 'dashboard.goal',
  NO_DATA_FOUND = 'dashboard.noData',
}
